import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;

export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;
export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const OuterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-weight: bold;
`;

export const RowTitleText = styled.h2`
  color: #474747;
  font-size: 22px;
  font-family: lato;
  text-transform: initial;
  margin-bottom: 20px;
  line-height: 1;
  margin-top: 8px;
  font-weight: bold;
`;

export const InformationBox = styled.div`
  width: 208%;
`;

export const CenterProductLink = styled.a`
  text-decoration: ${(props) => props.textDecoration} !important;
  color: #0a4986 !important;
  cursor: pointer;
  font-size: 15px;
  font-weight: 400;
`;

export const QuestionText = styled.div`
  color: #474747;
  font-size: 20px;
  font-family: lato;
  text-transform: initial;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: 24px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  margin-bottom: 10px;
`;
